<ng-template #inListTextFilterTemplate let-value let-filterCallback="filterCallback" let-filterConstraint="filterConstraint">
	@if (filterConstraint?.matchMode === 'in-list' || filterConstraint?.matchMode === 'not-in-list') {
		<textarea pInputTextarea rows="4" placeholder="Enter one value per line" [ngModel]="value" (ngModelChange)="filterCallback($event)"></textarea>
	} @else {
		<input pInputText type="text" [ngModel]="value" (ngModelChange)="filterCallback($event)" />
	}
</ng-template>
<router-outlet />
